import { render, staticRenderFns } from "./NewAdminLogin.vue?vue&type=template&id=ea101fd8&"
import script from "./NewAdminLogin.vue?vue&type=script&lang=js&"
export * from "./NewAdminLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports